import http from './public'

export default {
    // 获取产品详情
    item: (params) => {
        return http.fetchGet('item', params)
    },

    // 加入购物车
    addCartItem: (params) => {
        return http.fetchPost('cartItemAdd', params)
    },

    // 购物车数量
    getCartItemNum: (params) => {
        return http.fetchGet('getCartItemNum', params)
    },
    // 查询是否收藏
    isCollection: (params) => {
        return http.fetchGet('collection', params)
    },
    // 收藏 
    collectionAdd: (params) => {
        return http.fetchPost('collectionAdd', params)
    },
    // 移除 收藏 
    collectionDelete: (params) => {
        return http.fetchPost('collectionDelete', params)
    },
}